import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api/config";

export type ChargedPaymentMethod = "terminal" | "mbway";

export type ChargedOrderPayment = {
    order_payment_id: number;
    method: ChargedPaymentMethod;
};

const CHARGED_CHANNEL_BY_METHOD: Record<ChargedPaymentMethod, string> = { terminal: "no terminal", mbway: "por MB WAY" };

export const fetchChargedOrderPayments = async (orderId: number) => {
    const response = await api.get("/payments/orders/charged-payments", { params: { order_id: orderId } });
    const chargedPayments = response.data.data as Array<ChargedOrderPayment>;
    return chargedPayments;
};

export const useChargedOrderPayments = (orderId?: number) => {
    const chargedPaymentsQuery = useQuery({
        queryKey: [`orders_payments-charged-${orderId}`],
        queryFn: () => fetchChargedOrderPayments(orderId as number),
        enabled: orderId !== undefined,
    });
    return chargedPaymentsQuery;
};

export const findDeleteLockedReason = (orderPaymentId: number | undefined, chargedPayments: Array<ChargedOrderPayment>) => {
    const chargedPayment = chargedPayments.find((candidate) => candidate.order_payment_id === orderPaymentId);
    const deleteLockedReason = chargedPayment
        ? `Este pagamento foi cobrado ${CHARGED_CHANNEL_BY_METHOD[chargedPayment.method]} e não pode ser apagado. Fale com o responsável.`
        : undefined;
    return deleteLockedReason;
};
